/**
 * Client-side capture freshness. Distinct from transcript-staleness:
 * MediaRecorder timeslices fire every ~2s even in silence, so a gap here
 * means getUserMedia / the tab froze — not a quiet room.
 */

export const CAPTURE_STALL_MS = 15_000

export function evaluateCaptureFreshness(input: {
  isRecording: boolean
  isPaused: boolean
  lastAudioAt: number
  now: number
}): { stalled: boolean; silentSec: number } {
  if (!input.isRecording || input.isPaused) return { stalled: false, silentSec: 0 }
  const silentMs = input.now - input.lastAudioAt
  const silentSec = Math.max(0, Math.round(silentMs / 1000))
  return { stalled: silentMs > CAPTURE_STALL_MS, silentSec }
}
